import { batch, useDispatch } from 'react-redux';
import Link from 'next/link';

import { ISpecOffer } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { IDefaultPopup } from '@r1-frontend/ui-react/components/popups/defaultPopup';

import { LkPromotionalPopupExtra } from '~/src/features/specialOffersContainer/containers/popups/LkPromotionalPopupExtra';
import { setIsPopupOpened, setPopupState } from '~/src/features/specialOffersContainer/store/actions';

export const PromoConnectedPopup = ({ offer: { billingState }, ...props }: IDefaultPopup & { offer: ISpecOffer }) => {
    const dispatch = useDispatch();

    const clickHandler = () => {
        batch(() => {
            dispatch(setPopupState('none'));
            dispatch(setIsPopupOpened(false));
        });
    };

    return (
        <LkPromotionalPopupExtra
            message={`Акция ${billingState === 'connected' ? 'подключена' : 'отключена'}`}
            positive
            buttons={() => [
                <Link key={'btnToPromo'} href={'/lk/promo'} passHref>
                    <Button bType={'secondary'} data-test={'LkPromotionalPopupExtra-btntoactions'} onClick={clickHandler}>
                        В раздел «Акции»
                    </Button>
                </Link>,
            ]}
            {...props}
        />
    );
};
